/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'

import { useParams } from '@fs/zion-router'
import { usePageView } from '@fs/zion-analytics'
import { Toggle } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { usePageTitle } from '../../app/PageTitleContext'
import { useMessagesListController } from './useMessagesListController'
import CompactMessagesList from './compactMessagesList/CompactMessagesList'
import MessagesListTable from './MessagesListTable'

export default function MessagesList() {
  usePageView({ page_detail: `DMConsole:MessagesList:${useParams().queuesFilter}` })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.queues.messagesList'))
  const [compactMessageView, setCompactMessageView] = useState(() => {
    return localStorage.getItem('compactMessages') === 'true'
  })
  const { queueState, queueActions, queueCachesState } = useMessagesListController({ compactMessageView })

  useEffect(() => {
    localStorage.setItem('compactMessages', compactMessageView)
    if (!compactMessageView) {
      queueActions.setPageLimit(10)
    }
  }, [compactMessageView, queueActions])

  useEffect(() => {
    queueActions.prepareTemplate()
  }, [])

  useEffect(() => {
    queueActions.loadPagination()
  }, [
    queueState.queueName,
    queueState.queuePageIndex,
    queueState.pageLimit,
    queueState.sortField,
    queueState.sortDirection,
    queueState.query,
    queueState.treeCategories,
  ])

  if (!queueState.summaryComponent) {
    return null
  }

  return (
    <>
      <Toggle
        label={t('queues_tableView', 'Table View')}
        checked={compactMessageView}
        onChange={() => setCompactMessageView((prev) => !prev)}
      />

      {compactMessageView ? (
        <CompactMessagesList queueState={queueState} queueActions={queueActions} queueCachesState={queueCachesState} />
      ) : (
        queueState.queueContents.length <= 10 && (
          <MessagesListTable queueState={queueState} queueActions={queueActions} queueCachesState={queueCachesState} />
        )
      )}
    </>
  )
}
